import type { FC, HTMLAttributes } from 'react';

import { useGameConfig } from '../../../config/GameConfigProvider';
import { useCoreDispatch } from '../../../store/CoreStore';
import { chatActions } from '../../../store/slices/chat/slice';
import { useGameStateSlice } from '../../../store/slices/game/selectors';
import { useHeaderSlice } from '../../../store/slices/header/selectors';
import { headerActions } from '../../../store/slices/header/slice';
import { NavPages } from '../navPages/NavPagesConnected';

import { NavBurger } from './NavBurger';

export interface NavBurgerProps extends HTMLAttributes<HTMLDivElement> {}

export const NavBurgerConnected: FC<NavBurgerProps> = () => {
  const dispatch = useCoreDispatch();
  const isBetsOpen = useGameStateSlice.isBetsOpenStatus();
  const navOpen = useHeaderSlice.getNavOpen();
  const { navControls } = useGameConfig();

  const handleNavDrawerClose = (): void => {
    if (navOpen) {
      dispatch(chatActions.setIsChatClosed(true));
      dispatch(headerActions.setBetLimitsOpen(false));
    }
    if (navOpen) {
      dispatch(headerActions.setNavRoute([]));
    } else {
      dispatch(headerActions.pushNavRoute(NavPages.HOME));
    }
  };

  return (
    <NavBurger isLarge onClick={handleNavDrawerClose} navControls={navControls} navControlsCondition={isBetsOpen} />
  );
};
